var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('el-select', {
    staticClass: "w-full",
    attrs: {
      "prefix-icon": "",
      "placeholder": "",
      "value-key": "country",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.localValue,
      callback: function ($$v) {
        _vm.localValue = $$v;
      },
      expression: "localValue"
    }
  }, [_vm.getCountry() ? _c('div', {
    staticClass: "flex items-center h-full",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  }, [_c('flag', {
    attrs: {
      "country": _vm.getCountry()
    }
  })], 1) : _vm._e(), _vm._l(_vm.codes, function (i, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": i.label,
        "value": i.value
      }
    }, [_c('div', {
      staticClass: "flex items-center justify-between"
    }, [_c('div', {
      staticClass: "flag"
    }, [_c('img', {
      attrs: {
        "src": require(`/src/assets/country/` + i.country.toLowerCase() + `.png`)
      }
    })]), _c('div', {
      staticClass: "uppercase",
      domProps: {
        "textContent": _vm._s(`${i.country} ${i.label}`)
      }
    })])]);
  })], 2);
};

var staticRenderFns = [];
export { render, staticRenderFns };